import script from "./sidemenu-list.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidemenu-list.linux.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList});
